module.exports = __webpack_public_path__ + "img/hair_rituel-logo_black.6eb5756c.svg";